import { JwtHelperService } from '@auth0/angular-jwt';
import { createReducer, on } from '@ngrx/store';
import { shellLoginAction, shellLoginFailedAction, shellLoginSuccessAction, shellLogoutAction } from './shell.actions';
import { ShellState } from './shell.model';

const authToken = 'auth_token';
const jwt = new JwtHelperService({});

const initialToken = localStorage.getItem(authToken);
const isExpired = initialToken && jwt.isTokenExpired(initialToken);

const user = !isExpired 
    ? new JwtHelperService({}).decodeToken(initialToken)
    : null;

if (isExpired) {
    localStorage.removeItem(authToken);
}

const initialState = {
    token: user ? initialToken : null,
    user: user,
    message: null
} as ShellState;

export const shellReducer = createReducer(initialState,

    on(shellLoginAction, shellLogoutAction, (state: ShellState, data: any) => {
        localStorage.removeItem(authToken);
        return { ...state, user: null, token: null, message: null };
    }),

    on(shellLoginFailedAction, (state: ShellState, action) => {
        localStorage.removeItem(authToken);
        return { ...state, user: null, token: null, message: action.message };
    }),

    on(shellLoginSuccessAction, (state: ShellState, data: any) => {
        localStorage.setItem(authToken, data.token);
        return { ...state, user: data.user, token: data.token };
    })

);

export function safeShellReducer(state, action) {
    return shellReducer(state, action);
}
